// src/client/models/convertIssues.ts
import { getData } from '@/client/utils/db'

export default class ConvertIssuesModel {
    async list({ projectId, outTableId, page, limit, q, types, fileId }: any) {
        const params = new URLSearchParams()
        params.set('page', String(page ?? 1))
        params.set('limit', String(limit ?? 50))
        if (q) params.set('q', q)
        if (types?.length) params.set('types', types.join(','))
        if (fileId) params.set('fileId', fileId)

        return await getData(`/converter/${projectId}/issues/${outTableId}?${params.toString()}`)
    }
}
